import type { Drama } from "@/types";

export const dramas: Drama[] = [
  {
    id: 1,
    title: "星月之约",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20Korean%20romance%20drama%20poster%20featuring%20a%20young%20couple%20under%20a%20starry%20night%20sky%20with%20soft%20pink%20and%20lavender%20glow%2C%20elegant%20minimal%20composition%2C%20dreamy%20atmosphere%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20wide%20cinematic%20scene%20under%20a%20starry%20night%20sky%20with%20soft%20pink%20glow%20and%20city%20lights%20bokeh%2C%20dreamy%20fantasy%20mood%2C%20elegant%20and%20atmospheric&width=1600&height=900&seq=drama-banner-01&orientation=landscape",
    year: 2025,
    genres: ["爱情", "奇幻"],
    rating: 9.1,
    cast: ["李承宰", "朴敏彩", "徐志勋"],
    director: "金泰允",
    writer: "郑慧琳",
    episodes: 16,
    status: "更新中",
    region: "韩国",
    tags: ["浪漫", "穿越", "高甜"],
    hot: 9860,
    featured: true,
    synopsis: [
      "天文学家车允熙在一次观测中意外接收到来自百年前的神秘信号，并因此与素未谋面的旧时代青年韩世洲产生了跨越时空的联系。两人通过每晚星空下的短暂相遇，逐渐走进彼此孤独的世界。",
      "当命运的齿轮开始转动，允熙必须在回到现实与守护这段注定无法拥有的感情之间做出抉择。一段关于星辰、时间与勇气的浪漫故事就此展开。",
    ],
    episodeList: [
      { no: 1, title: "来自星空的信号", summary: "车允熙在观测台捕捉到一段无法解释的旧信号，命运由此改变。" },
      { no: 2, title: "第一次相遇", summary: "星空之下，允熙与韩世洲初次对话，彼此都以为是幻觉。" },
      { no: 3, title: "被记住的名字", summary: "世洲开始寻找关于允熙的一切线索，却发现她并不存在于这个时代。" },
      { no: 4, title: "时间的裂缝", summary: "两次相遇的时间越来越短，两人开始意识到这段联系的代价。" },
      { no: 5, title: "无声的约定", summary: "他们约定在同一片星空下等待彼此，哪怕只为一个瞬间。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Korean%20drama%20behind%20the%20scenes%20still%20of%20a%20young%20couple%20conversing%20in%20an%20observatory%20at%20night%2C%20warm%20pink%20ambient%20lighting%2C%20cinematic%20tone&width=800&height=600&seq=drama-still-011&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Korean%20drama%20scene%20with%20a%20woman%20looking%20at%20a%20starlit%20sky%20through%20a%20large%20telescope%2C%20soft%20blue%20and%20pink%20gradient%2C%20emotional%20mood&width=800&height=600&seq=drama-still-012&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20still%20of%20two%20silhouettes%20standing%20on%20a%20rooftop%20under%20stars%2C%20warm%20cinematic%20color%20grading&width=800&height=600&seq=drama-still-013&orientation=landscape",
    ],
  },
  {
    id: 2,
    title: "首尔迷雾",
    cover: "https://readdy.ai/api/search-image?query=Moody%20Korean%20crime%20thriller%20poster%20of%20a%20detective%20silhouette%20in%20a%20rainy%20Seoul%20alley%20with%20neon%20reflections%2C%20tense%20dark%20atmosphere%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Rainy%20Seoul%20city%20street%20at%20night%20with%20neon%20signs%20and%20misty%20fog%2C%20cinematic%20crime%20thriller%20mood%2C%20cool%20desaturated%20tones%20with%20warm%20accents&width=1600&height=900&seq=drama-banner-02&orientation=landscape",
    year: 2025,
    genres: ["悬疑", "犯罪"],
    rating: 8.8,
    cast: ["姜道贤", "尹世拉", "吴成宇"],
    director: "崔民浩",
    writer: "韩智恩",
    episodes: 12,
    status: "已完结",
    region: "韩国",
    tags: ["烧脑", "推理", "暗黑"],
    hot: 8720,
    featured: true,
    synopsis: [
      "首尔连续发生多起看似毫无关联的失踪案，重案组刑警姜道贤在调查中逐渐发现，所有线索都指向十年前一桩被草草结案的旧案。",
      "随着调查深入，真相背后的迷雾越来越浓，道贤不得不面对自己最不愿提起的过去。一场关于正义与救赎的较量正式打响。",
    ],
    episodeList: [
      { no: 1, title: "雨夜的报案", summary: "一起离奇的失踪案打破了重案组平静的日常。" },
      { no: 2, title: "十年前的档案", summary: "道贤在旧档案里发现了被刻意抹去的一页。" },
      { no: 3, title: "沉默的证人", summary: "唯一的目击者却在关键时刻改口。" },
      { no: 4, title: "迷雾深处", summary: "真相的一角浮出水面，代价却超乎想象。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20still%20of%20a%20detective%20examining%20case%20files%20in%20a%20dim%20office%2C%20moody%20lighting%2C%20cinematic&width=800&height=600&seq=drama-still-021&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Rainy%20Seoul%20alleyway%20at%20night%20with%20neon%20reflections%20on%20wet%20pavement%2C%20crime%20thriller%20cinematic%20mood&width=800&height=600&seq=drama-still-022&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Korean%20thriller%20scene%20of%20two%20people%20in%20a%20tense%20interrogation%20room%2C%20cold%20tones%2C%20dramatic%20lighting&width=800&height=600&seq=drama-still-023&orientation=landscape",
    ],
  },
  {
    id: 3,
    title: "那年盛夏",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20Korean%20youth%20romance%20poster%20of%20students%20in%20school%20uniforms%20under%20sunlit%20summer%20trees%2C%20warm%20bright%20tones%2C%20bittersweet%20mood%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Sunlit%20summer%20countryside%20road%20with%20green%20trees%20and%20warm%20golden%20light%2C%20nostalgic%20youth%20drama%20cinematic%20mood%2C%20bright%20and%20airy&width=1600&height=900&seq=drama-banner-03&orientation=landscape",
    year: 2024,
    genres: ["青春", "爱情"],
    rating: 8.5,
    cast: ["朴志勋", "金多恩", "李在民"],
    director: "白承勋",
    writer: "柳娜英",
    episodes: 14,
    status: "已完结",
    region: "韩国",
    tags: ["校园", "怀旧", "治愈"],
    hot: 7540,
    featured: true,
    synopsis: [
      "1998 年的夏天，转学生尹秀雅来到海边小镇，遇见了热爱摄影的少年朴海俊。两个青春期的少年少女在蝉鸣与海风中，写下了属于那个夏天最珍贵的记忆。",
      "多年后，当秀雅再次翻开那本旧相册，所有的欢笑与遗憾都重新涌上心头。一段关于成长与告别的小镇往事。",
    ],
    episodeList: [
      { no: 1, title: "转学的夏天", summary: "秀雅拖着行李箱走进这座安静的海边小镇。" },
      { no: 2, title: "海边的相机", summary: "海俊的镜头里，第一次出现了秀雅的身影。" },
      { no: 3, title: "蝉鸣的午后", summary: "两颗心在漫长的夏日午后慢慢靠近。" },
      { no: 4, title: "来不及说的再见", summary: "夏天结束时，有些话终究没能说出口。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Korean%20youth%20drama%20still%20of%20students%20cycling%20along%20a%20sunlit%20coastal%20road%2C%20warm%20nostalgic%20tones&width=800&height=600&seq=drama-still-031&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Korean%20drama%20scene%20of%20a%20teenager%20holding%20an%20old%20camera%20near%20the%20sea%20at%20sunset%2C%20warm%20golden%20light&width=800&height=600&seq=drama-still-032&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Summer%20beach%20in%20Korea%20with%20pier%20and%20warm%20sunset%20colors%2C%20nostalgic%20cinematic%20mood&width=800&height=600&seq=drama-still-033&orientation=landscape",
    ],
  },
  {
    id: 4,
    title: "王宫医女",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20Korean%20historical%20drama%20poster%20of%20a%20female%20physician%20in%20traditional%20hanbok%20inside%20a%20royal%20palace%2C%20ornate%20details%2C%20warm%20gold%20and%20deep%20red%20palette%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Traditional%20Korean%20royal%20palace%20courtyard%20at%20dusk%20with%20ornate%20architecture%20and%20warm%20lanterns%2C%20historical%20drama%20cinematic%20mood%2C%20rich%20gold%20and%20red%20tones&width=1600&height=900&seq=drama-banner-04&orientation=landscape",
    year: 2024,
    genres: ["古装", "历史", "剧情"],
    rating: 9.0,
    cast: ["崔秀珍", "李贤宇", "郑在勋"],
    director: "徐东延",
    writer: "闵素珍",
    episodes: 20,
    status: "已完结",
    region: "韩国",
    tags: ["宫斗", "励志", "大女主"],
    hot: 8210,
    featured: true,
    synopsis: [
      "出身医官世家的少女崔莲伊自幼聪慧过人，凭借过人胆识进入王宫成为一名医女。在那个女子不得从医的年代，她用医术与智慧一步步赢得信任。",
      "宫廷权谋暗流涌动，莲伊不仅要救治病患，更要在权力漩涡中守护自己的信念。一段关于医者仁心的传奇故事。",
    ],
    episodeList: [
      { no: 1, title: "入宫", summary: "莲伊带着父亲的嘱托踏入王宫的大门。" },
      { no: 2, title: "第一次诊脉", summary: "一场突如其来的急症考验着她的医术。" },
      { no: 3, title: "暗涌", summary: "宫廷中的流言开始向她袭来。" },
      { no: 4, title: "医者之心", summary: "面对两难抉择，莲伊守住了一生的信念。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Korean%20historical%20drama%20still%20of%20a%20female%20physician%20preparing%20herbs%20in%20a%20traditional%20apothecary%2C%20warm%20candlelight&width=800&height=600&seq=drama-still-041&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Ornate%20Korean%20palace%20hall%20with%20traditional%20screen%20and%20lanterns%2C%20historical%20cinematic%20interior&width=800&height=600&seq=drama-still-042&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Traditional%20Korean%20hanbok%20details%20with%20embroidery%20in%20warm%20golden%20light%2C%20elegant%20closeup&width=800&height=600&seq=drama-still-043&orientation=landscape",
    ],
  },
  {
    id: 5,
    title: "重启心跳",
    cover: "https://readdy.ai/api/search-image?query=Korean%20medical%20drama%20poster%20of%20a%20confident%20doctor%20in%20a%20hospital%20corridor%20with%20soft%20teal%20and%20white%20tones%2C%20clean%20modern%20composition%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Modern%20hospital%20interior%20with%20glass%20walls%20and%20soft%20daylight%2C%20Korean%20medical%20drama%20cinematic%20mood%2C%20clean%20clinical%20tones&width=1600&height=900&seq=drama-banner-05&orientation=landscape",
    year: 2025,
    genres: ["医疗", "剧情"],
    rating: 8.7,
    cast: ["金善浩", "文佳英", "崔宇植"],
    director: "郑宇成",
    writer: "表娜丽",
    episodes: 16,
    status: "更新中",
    region: "韩国",
    tags: ["热血", "职业", "群像"],
    hot: 7990,
    featured: false,
    synopsis: [
      "天才心脏外科医生金善浩在事业巅峰时遭遇医疗事故的指控，被迫离开大医院，来到一家经费紧张的社区急救中心。",
      "在这里，他重新认识了医者的初心，并与一群性格各异的同事并肩作战，在生死之间重启自己早已麻木的心跳。",
    ],
    episodeList: [
      { no: 1, title: "坠落", summary: "一场意外让善浩的职业生涯跌入谷底。" },
      { no: 2, title: "陌生的诊室", summary: "社区急救中心迎来了一位不速之客。" },
      { no: 3, title: "争分夺秒", summary: "一次连环事故考验着整个团队。" },
      { no: 4, title: "重新出发", summary: "善浩第一次主动拿起了手术刀。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Korean%20medical%20drama%20still%20of%20doctors%20in%20a%20busy%20emergency%20room%2C%20clean%20clinical%20lighting&width=800&height=600&seq=drama-still-051&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Surgeon%20washing%20hands%20before%20surgery%20in%20a%20hospital%2C%20dramatic%20focused%20lighting%2C%20cinematic&width=800&height=600&seq=drama-still-052&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20Korean%20hospital%20exterior%20at%20dusk%20with%20glass%20facade%2C%20clean%20architectural%20photography&width=800&height=600&seq=drama-still-053&orientation=landscape",
    ],
  },
  {
    id: 6,
    title: "江南往事",
    cover: "https://readdy.ai/api/search-image?query=Korean%20family%20drama%20poster%20of%20a%20multi-generational%20family%20in%20a%20modern%20city%20apartment%2C%20warm%20slice%20of%20life%20tone%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Modern%20Seoul%20Gangnam%20district%20skyline%20at%20twilight%20with%20warm%20window%20lights%2C%20family%20drama%20cinematic%20mood&width=1600&height=900&seq=drama-banner-06&orientation=landscape",
    year: 2024,
    genres: ["现代", "家庭", "剧情"],
    rating: 8.3,
    cast: ["朴海真", "金宥真", "李顺载"],
    director: "罗英淑",
    writer: "河英美",
    episodes: 40,
    status: "已完结",
    region: "韩国",
    tags: ["生活", "群像", "温情"],
    hot: 6320,
    featured: false,
    synopsis: [
      "在首尔江南区经营着一家老式小餐馆的朴家三代同堂，看似平凡的生活下藏着各自的心事与梦想。",
      "随着城市变迁与家庭矛盾的交织，一家人学会在碰撞与理解中重新找回彼此。一部温暖人心的家庭群像剧。",
    ],
    episodeList: [
      { no: 1, title: "老餐馆", summary: "朴家的小餐馆迎来了一位特殊的客人。" },
      { no: 2, title: "搬家风波", summary: "拆迁的消息让平静的家庭再起波澜。" },
      { no: 3, title: "藏在抽屉里的信", summary: "一封旧信揭开了父亲尘封多年的往事。" },
      { no: 4, title: "团圆饭", summary: "一家人终于在餐桌前坐下，说出心里话。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Cozy%20Korean%20family%20gathering%20around%20a%20table%20full%20of%20food%2C%20warm%20homely%20lighting&width=800&height=600&seq=drama-still-061&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Small%20traditional%20Korean%20restaurant%20interior%20with%20warm%20wood%20and%20lanterns&width=800&height=600&seq=drama-still-062&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Seoul%20residential%20neighborhood%20alley%20at%20dusk%20with%20warm%20lights%2C%20nostalgic%20tone&width=800&height=600&seq=drama-still-063&orientation=landscape",
    ],
  },
  {
    id: 7,
    title: "无声证词",
    cover: "https://readdy.ai/api/search-image?query=Korean%20legal%20thriller%20drama%20poster%20of%20a%20female%20prosecutor%20holding%20documents%20in%20a%20courtroom%2C%20cool%20grey%20and%20warm%20accent%20palette%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Formal%20Korean%20courtroom%20interior%20with%20dramatic%20lighting%20and%20empty%20seats%2C%20legal%20thriller%20cinematic%20mood&width=1600&height=900&seq=drama-banner-07&orientation=landscape",
    year: 2025,
    genres: ["悬疑", "律政"],
    rating: 8.9,
    cast: ["孙艺珍", "李帝勋", "金武烈"],
    director: "张荷娜",
    writer: "孔善浩",
    episodes: 12,
    status: "已完结",
    region: "韩国",
    tags: ["法庭", "反转", "正义"],
    hot: 8460,
    featured: true,
    synopsis: [
      "检察官孙艺珍接手了一桩看似证据确凿的杀人案，却在庭审前夜收到匿名线索，指向一个被所有人忽视的真相。",
      "越是接近真相，阻力越大。她必须在舆论、权力与良心之间，为沉默的证词发声。",
    ],
    episodeList: [
      { no: 1, title: "开庭前夜", summary: "一封匿名信让艺珍对案件产生了怀疑。" },
      { no: 2, title: "被忽略的细节", summary: "重新梳理的证据链出现了断裂。" },
      { no: 3, title: "证人席上", summary: "关键证人的证词在场内引起轩然大波。" },
      { no: 4, title: "最后陈述", summary: "艺珍在法庭上说出了所有人都不敢说的话。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Korean%20legal%20drama%20still%20of%20a%20prosecutor%20reviewing%20evidence%20at%20a%20dim%20desk%2C%20cinematic%20lighting&width=800&height=600&seq=drama-still-071&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Dramatic%20empty%20courtroom%20with%20warm%20wood%20and%20soft%20spotlight%2C%20tense%20mood&width=800&height=600&seq=drama-still-072&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Two%20people%20in%20heated%20discussion%20in%20a%20modern%20office%2C%20cool%20grey%20and%20warm%20accent%20tones&width=800&height=600&seq=drama-still-073&orientation=landscape",
    ],
  },
  {
    id: 8,
    title: "甜蜜告白",
    cover: "https://readdy.ai/api/search-image?query=Bright%20romantic%20comedy%20Korean%20drama%20poster%20of%20a%20cheerful%20couple%20with%20pastel%20pink%20and%20cream%20background%2C%20playful%20modern%20composition%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Bright%20pastel%20city%20cafe%20street%20in%20Korea%20with%20cherry%20blossoms%20and%20warm%20sunlight%2C%20romantic%20comedy%20cinematic%20mood&width=1600&height=900&seq=drama-banner-08&orientation=landscape",
    year: 2025,
    genres: ["爱情", "喜剧"],
    rating: 8.2,
    cast: ["安晓妍", "车银浩", "郑素敏"],
    director: "洪智雅",
    writer: "南多顺",
    episodes: 16,
    status: "更新中",
    region: "韩国",
    tags: ["轻松", "甜宠", "下饭"],
    hot: 7180,
    featured: false,
    synopsis: [
      "甜品店老板安晓妍最讨厌的是挑剔的美食专栏作家车银浩，偏偏对方成了她店铺隔壁的邻居。",
      "从互看不顺眼到慢慢发现彼此的温柔，一场关于甜点、误会与心动的轻喜剧悄然上演。",
    ],
    episodeList: [
      { no: 1, title: "隔壁的新邻居", summary: "晓妍的甜品店迎来了一位难缠的邻居。" },
      { no: 2, title: "差评风波", summary: "一篇专栏文章让店铺生意一落千丈。" },
      { no: 3, title: "深夜的蛋糕", summary: "银浩在打烊后敲响了甜品店的门。" },
      { no: 4, title: "说不出口的甜", summary: "两人之间的那层窗户纸即将被捅破。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Bright%20pastel%20Korean%20dessert%20shop%20interior%20with%20cakes%20and%20warm%20sunlight&width=800&height=600&seq=drama-still-081&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cherry%20blossom%20street%20in%20Korea%20with%20a%20couple%20walking%2C%20soft%20pink%20tones&width=800&height=600&seq=drama-still-082&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20colorful%20Korean%20desserts%20on%20a%20pastel%20table%2C%20bright%20airy%20food%20photography&width=800&height=600&seq=drama-still-083&orientation=landscape",
    ],
  },
  {
    id: 9,
    title: "明日之地",
    cover: "https://readdy.ai/api/search-image?query=Korean%20sci-fi%20drama%20poster%20of%20a%20lone%20survivor%20standing%20before%20a%20futuristic%20ruined%20city%2C%20cool%20teal%20and%20amber%20palette%2C%20epic%20cinematic%20mood&width=600&height=800&seq=drama-cover-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Futuristic%20post-apocalyptic%20city%20skyline%20with%20cool%20teal%20sky%20and%20amber%20glow%2C%20Korean%20sci-fi%20drama%20cinematic%20mood&width=1600&height=900&seq=drama-banner-09&orientation=landscape",
    year: 2025,
    genres: ["科幻", "末世", "剧情"],
    rating: 8.6,
    cast: ["玄彬宇", "韩素希", "孔侑民"],
    director: "李政宰",
    writer: "权恩希",
    episodes: 12,
    status: "更新中",
    region: "韩国",
    tags: ["科幻", "末日", "人性"],
    hot: 7680,
    featured: false,
    synopsis: [
      "在资源枯竭的近未来，幸存者们聚集在最后一座地下城市。负责搜寻物资的玄彬宇在一次任务中发现了城市建立之初被隐瞒的真相。",
      "当希望与现实冲突，人们必须选择是继续活在谎言里，还是赌上一切走向明日之地。",
    ],
    episodeList: [
      { no: 1, title: "最后的城市", summary: "地下城的一天从配给名册开始。" },
      { no: 2, title: "禁区任务", summary: "彬宇带队进入被封锁的地表区域。" },
      { no: 3, title: "被抹去的档案", summary: "一段旧录像颠覆了所有人的认知。" },
      { no: 4, title: "黎明之前", summary: "城市即将迎来它最后的决定。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Futuristic%20underground%20city%20with%20cool%20teal%20lighting%20and%20towering%20structures%2C%20sci-fi%20cinematic&width=800&height=600&seq=drama-still-091&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Post-apocalyptic%20desert%20landscape%20with%20ruins%20and%20amber%20sunset%2C%20cinematic%20wide%20shot&width=800&height=600&seq=drama-still-092&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sci-fi%20control%20room%20with%20holographic%20screens%20in%20cool%20blue%20tones%2C%20cinematic&width=800&height=600&seq=drama-still-093&orientation=landscape",
    ],
  },
  {
    id: 10,
    title: "花样厨房",
    cover: "https://readdy.ai/api/search-image?query=Warm%20healing%20Korean%20drama%20poster%20of%20a%20cozy%20kitchen%20with%20fresh%20ingredients%20and%20a%20chef%2C%20warm%20cream%20and%20green%20tones%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cozy%20rustic%20Korea%20countryside%20kitchen%20with%20fresh%20vegetables%20and%20warm%20morning%20light%2C%20healing%20drama%20cinematic%20mood&width=1600&height=900&seq=drama-banner-10&orientation=landscape",
    year: 2024,
    genres: ["治愈", "美食", "生活"],
    rating: 8.4,
    cast: ["李瑞镇", "全美都", "朴素丹"],
    director: "尹多英",
    writer: "白珍熙",
    episodes: 16,
    status: "已完结",
    region: "韩国",
    tags: ["治愈", "美食", "慢生活"],
    hot: 5990,
    featured: false,
    synopsis: [
      "厌倦了城市快节奏生活的厨师李瑞镇回到乡下外婆留下的小院，开起了一间只做当季料理的小餐馆。",
      "一道道家常菜串起了邻里之间的温暖故事，也让瑞镇慢慢找回了生活的味道。",
    ],
    episodeList: [
      { no: 1, title: "回乡", summary: "瑞镇带着一身疲惫回到外婆的小院。" },
      { no: 2, title: "第一位客人", summary: "小餐馆迎来了一位独自旅行的客人。" },
      { no: 3, title: "妈妈的食谱", summary: "一道熟悉的菜唤起了尘封的记忆。" },
      { no: 4, title: "四季的味道", summary: "小院在四季流转中有了新的名字。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Cozy%20rustic%20Korean%20countryside%20kitchen%20with%20fresh%20vegetables%20in%20warm%20light&width=800&height=600&seq=drama-still-101&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20colorful%20homemade%20Korean%20dishes%20on%20a%20wooden%20table&width=800&height=600&seq=drama-still-102&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Peaceful%20Korean%20village%20garden%20with%20vegetable%20beds%20and%20warm%20sunlight&width=800&height=600&seq=drama-still-103&orientation=landscape",
    ],
  },
  {
    id: 11,
    title: "双面追凶",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20thriller%20poster%20of%20a%20battle-worn%20detective%20against%20a%20dark%20city%20backdrop%2C%20high%20contrast%20with%20warm%20orange%20accents%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Night%20city%20rooftop%20chase%20scene%20with%20warm%20orange%20streetlights%20and%20dark%20sky%2C%20action%20thriller%20cinematic%20mood&width=1600&height=900&seq=drama-banner-11&orientation=landscape",
    year: 2025,
    genres: ["悬疑", "动作"],
    rating: 8.5,
    cast: ["马东锡", "金南佶", "林智妍"],
    director: "赵元熙",
    writer: "崔俊浩",
    episodes: 14,
    status: "更新中",
    region: "韩国",
    tags: ["追凶", "动作", "硬核"],
    hot: 8020,
    featured: false,
    synopsis: [
      "刑警马东锡追查一名连环凶手，却发现对方似乎总能预判警方的每一步，仿佛是同一个人在镜子的两端。",
      "随着案件推进，他不得不怀疑，真凶或许就藏在自己最信任的人当中。",
    ],
    episodeList: [
      { no: 1, title: "镜像", summary: "一起案件的手法与十年前的旧案如出一辙。" },
      { no: 2, title: "跟踪者", summary: "东锡发现自己被人反过来盯上了。" },
      { no: 3, title: "假面", summary: "关键嫌疑人露出了破绽。" },
      { no: 4, title: "正面对决", summary: "天台上，两个追凶者终于相遇。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Korean%20action%20thriller%20still%20of%20a%20detective%20running%20through%20a%20dark%20alley%2C%20dynamic%20motion%2C%20cinematic&width=800&height=600&seq=drama-still-111&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Night%20city%20rooftop%20with%20warm%20orange%20lights%20and%20dark%20sky%2C%20tense%20standoff&width=800&height=600&seq=drama-still-112&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Cinematic%20close-up%20of%20a%20suspect%20in%20shadow%20with%20warm%20rim%20light&width=800&height=600&seq=drama-still-113&orientation=landscape",
    ],
  },
  {
    id: 12,
    title: "恋恋笔记",
    cover: "https://readdy.ai/api/search-image?query=Soft%20romantic%20Korean%20drama%20poster%20of%20a%20woman%20writing%20in%20a%20notebook%20by%20a%20window%20with%20warm%20afternoon%20light%2C%20cream%20and%20rose%20palette%2C%20premium%20poster%20art&width=600&height=800&seq=drama-cover-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Warm%20sunlit%20study%20room%20with%20open%20notebooks%20and%20coffee%2C%20soft%20cream%20tones%2C%20romantic%20drama%20cinematic%20mood&width=1600&height=900&seq=drama-banner-12&orientation=landscape",
    year: 2024,
    genres: ["爱情", "现代"],
    rating: 8.1,
    cast: ["丁海寅", "金高银", "李到晛"],
    director: "申允书",
    writer: "吴世莉",
    episodes: 16,
    status: "已完结",
    region: "韩国",
    tags: ["细水长流", "治愈", "现实"],
    hot: 6540,
    featured: false,
    synopsis: [
      "出版社编辑金高银在整理旧稿件时，发现一本没有署名的恋恋笔记，记录着一段跨越多年的暗恋。",
      "当她试图找到笔记的主人时，却意外与自己曾经错过的年少时光重逢。",
    ],
    episodeList: [
      { no: 1, title: "没有署名的稿子", summary: "高银在仓库里发现了一本旧笔记。" },
      { no: 2, title: "字里行间", summary: "笔记中的地名与她的过去重叠。" },
      { no: 3, title: "迟到多年的信", summary: "一段沉默的暗恋终于有了回音。" },
      { no: 4, title: "写在最后", summary: "高银在笔记的最后一页写下了自己的答案。" },
    ],
    gallery: [
      "https://readdy.ai/api/search-image?query=Warm%20sunlit%20desk%20with%20an%20open%20notebook%20and%20coffee%2C%20soft%20cream%20tones&width=800&height=600&seq=drama-still-121&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Quiet%20Korean%20bookstore%20interior%20with%20warm%20wood%20and%20soft%20light&width=800&height=600&seq=drama-still-122&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Two%20people%20sitting%20quietly%20by%20a%20window%20with%20afternoon%20light%2C%20gentle%20romantic%20mood&width=800&height=600&seq=drama-still-123&orientation=landscape",
    ],
  },
];